import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/brand/social media branding.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const SocialMediaBranding = () => {
  const heroData = {
    title: "Strategic Social Media Branding",
    description: "Build a powerful social media presence that engages your audience and strengthens brand loyalty. We create comprehensive social media strategies and content that drive real business results.",
    image: img13,
    imageAlt: "Social Media Branding",
    features: [
      "Platform strategy",
      "Content calendar",
      "Visual branding",
      "Community management",
      "Engagement tactics",
      "Analytics & reporting",
    ],
    pillars: [
      "Strategic content that resonates with your target audience",
      "Consistent brand voice across all social platforms",
      "Data-driven optimization that maximizes engagement and reach",
    ],
  };

  const journeySteps = [
    {
      title: "Audit & Strategy",
      description: "We analyze your current social presence, audience, competitors, and opportunities to build a winning strategy.",
      details: ["Social media audit", "Audience analysis", "Competitor benchmarking", "Platform selection", "Content pillars", "KPI definition"],
    },
    {
      title: "Brand Guidelines & Templates",
      description: "We create social-specific brand guidelines with custom templates that ensure consistent, on-brand content creation.",
      details: ["Social brand guide", "Content templates", "Visual style", "Tone of voice", "Hashtag strategy", "Bio optimization"],
    },
    {
      title: "Content Strategy & Calendar",
      description: "Our team develops a comprehensive content strategy with detailed calendars that balance promotional, educational, and engaging content.",
      details: ["Content strategy", "30-day calendar", "Post concepts", "Copy & captions", "Visual concepts", "Posting schedule"],
    },
    {
      title: "Launch & Growth",
      description: "We launch your strategy with community management, engagement tactics, and ongoing optimization based on performance data.",
      details: ["Content rollout", "Community engagement", "Influencer outreach", "Paid amplification", "Performance tracking", "Monthly reporting"],
    },
  ];

  const capabilities = [
    {
      title: "Multi-Platform Strategy",
      content:
        "Tailored strategies for Instagram, Facebook, LinkedIn, Twitter/X, TikTok, YouTube, and Pinterest with platform-specific best practices.",
    },
    {
      title: "Content Creation",
      content:
        "Professional content production including graphics, videos, reels, stories, and carousel posts optimized for each platform.",
    },
    {
      title: "Community Management",
      content:
        "Active community engagement, response management, conversation building, and relationship development with your audience.",
    },
    {
      title: "Influencer Partnerships",
      content:
        "Strategic influencer identification, outreach, relationship management, and campaign execution for amplified reach.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "285%", label: "Average follower growth" },
      { value: "4.8%", label: "Average engagement rate" },
      { value: "350%", label: "Increase in brand mentions" },
    ],
    description: "We deliver social media strategies that drive significant growth in followers, engagement, and brand awareness across all platforms.",
  };

  const outcomesData = {
    description: "We create comprehensive social media strategies that build engaged communities, strengthen brand presence, and drive measurable business results.",
    outcomes: [
      "Platform-specific social media strategy",
      "30-day content calendar with concepts",
      "Custom branded social media templates",
      "Daily community management and engagement",
      "Monthly analytics and performance reports",
      "Ongoing optimization and strategy evolution",
    ],
  };

  const whyChooseUs = [
    {
      title: "Platform Expertise",
      content:
        "Deep knowledge of each platform's algorithm, features, and best practices to maximize your reach and engagement.",
    },
    {
      title: "Creative Excellence",
      content:
        "Our content stands out in crowded feeds with scroll-stopping visuals and compelling copy that drives action.",
    },
    {
      title: "Community First",
      content:
        "We build real relationships with your audience through authentic engagement and valuable content, not just broadcasting.",
    },
    {
      title: "Data-Driven Growth",
      content:
        "Continuous optimization based on analytics and insights ensures steady growth and improving performance over time.",
    },
  ];

  const faqs = [
    {
      q: "Which social media platforms should my business be on?",
      a: "It depends on your target audience and business goals. B2B companies typically thrive on LinkedIn, visual brands excel on Instagram and Pinterest, younger audiences are on TikTok, and Facebook remains strong for community building. We conduct audience research to recommend the optimal platform mix for your specific business."
    },
    {
      q: "How often should we post on social media?",
      a: "Posting frequency varies by platform and audience. Generally, Instagram/Facebook benefit from 4-7 posts per week, LinkedIn 3-5 times weekly, Twitter/X multiple times daily, and TikTok 3-7 times weekly. We create a customized content calendar based on your resources, goals, and audience engagement patterns."
    },
    {
      q: "Do you handle community management and responses?",
      a: "Yes! Community management is crucial for building relationships and brand loyalty. Our team monitors your social channels daily, responds to comments and messages, engages with your audience, and manages conversations. We work with you to establish response protocols and brand voice guidelines."
    },
    {
      q: "How do you measure social media success?",
      a: "We track meaningful metrics aligned with your goals: follower growth, engagement rate (likes, comments, shares), reach and impressions, website clicks, lead generation, and conversion. Monthly reports show performance trends, top-performing content, audience insights, and recommendations for continuous improvement."
    }
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Social Media Branding"}
            pagesub={"Branding & Design"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Social Media Branding Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default SocialMediaBranding;
